<template>
<div class="chapter">
<div class="inner_page">
<div class="plates" id="plates32">
<p class="centerImage"><img alt="images" id="plate32" src="images/plate32.jpg"/></p>
<p class="caption">Our pilot hut at dispersal, Darwin, 1943. Robin Norwood sits far left while Bob Ashby stands at the side of him having a fag. Tony Brooks is asleep far right.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_TallyHo_plates32.vue?029bea5e